import {makeStyles} from '@material-ui/core/styles';
import React, {useEffect, useState} from 'react';
import useLayoutStore from "../../layoutStore";
import usePersistentStore from "../../persistentStore";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import DoneIcon from '@material-ui/icons/Done';
import Radio from "@material-ui/core/Radio";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import useClipboard from "react-use-clipboard";
import withStyles from "@material-ui/core/styles/withStyles";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
import {notify} from "../../utils/notify";

const stopwords = require('stopwords-iso');  // object of stopwords for multiple languages
const english = stopwords.en;  // English stopwords

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    selections: {
        height: 120,
        width: '100%',
        overflowY: 'scroll',
        fontSize: '80%',
        display: 'flex',
        listStyle: 'none',
        justifyContent: 'left',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        paddingLeft: 0,
        '& > *': {
            margin: theme.spacing(0.2),
        },
    },
    radios: {
        flexDirection: 'row',
    },
    buttons: {
        padding: 3
    }
}));

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles((theme) => ({
    root: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);

const PopupAnalyzeKeywords = props => {
    const classes = useStyles();
    const [globalLayoutState] = useLayoutStore();
    const [globalPersistentState] = usePersistentStore();
    const [unselectedPhrases, setUnselectedPhrases] = useState([]);
    const [selectedPhrases, setSelectedPhrases] = useState([]);
    const [selectionComma, setSelectionComma] = useState('');
    const [selectionBullet, setSelectionBullet] = useState('');
    const [selectionList, setSelectionList] = useState('');
    const [selectedRadio, setSelectedRadio] = useState(0);
    // eslint-disable-next-line no-unused-vars
    const [isCopiedComma, setCopiedComma] = useClipboard(selectionComma);
    // eslint-disable-next-line no-unused-vars
    const [isCopiedBullet, setCopiedBullet] = useClipboard(selectionBullet);
    // eslint-disable-next-line no-unused-vars
    const [isCopiedHTML, setCopiedHTML] = useClipboard(selectionList);
    const [copyAnchorEl, setCopyAnchorEl] = useState(null);
    const endSentence = 'Zzzzzz';

    // const {data: getUserPreferencesData} = useQuery(GET_USER_PREFERENCES);
    //
    // useEffect(() => {
    //     if (getUserPreferencesData && getUserPreferencesData.userPreferences && getUserPreferencesData.userPreferences.length > 0) {
    //         const objs = getUserPreferencesData.userPreferences.filter(pObj => pObj.key === 'popupPrefs');
    //         if (objs.length > 0) {
    //             const val = objs[0].value;
    //             if (val.length > 0) tellParentMessage({userPreferences: JSON.parse(val)}, globalPersistentState.popupQueryObj)
    //         }
    //     }
    // }, [getUserPreferencesData]);

    const handleCopyClick = (event) => {
        setCopyAnchorEl(event.currentTarget);
    };

    const handleCopyItemClick = (event, type) => {
        if (type === 'comma') {
            setCopiedComma();
        } else if (type === 'bullet') {
            setCopiedBullet();
        } else if (type === 'html') {
            setCopiedHTML();
        }
        notify('copied', 'info', "copied", null, null, globalPersistentState.popupQueryObj);
        setCopyAnchorEl(null);
    };

    const handleCopyClose = () => {
        setCopyAnchorEl(null);
    };

    const insertPhrase = (phrase, location, wordCount, phraseArray) => {
        let found = phraseArray.find(obj => obj.keyPhrase === phrase);
        if (!found) {
            phraseArray.push({
                id: phrase.replace(/\s\s+/, '-').toLowerCase(),
                keyPhrase: phrase,
                location: location,
                weight: 0,
                wordCount: wordCount,
                count: 1
            })
        } else {
            found.count++;
        }
    }

    function compareWeight(a, b) {
        let comparison = 0;
        if (a.weight > b.weight) {
            comparison = -1;
        } else if (a.weight < b.weight) {
            comparison = 1;
        }
        return comparison;
    }

    useEffect(() => {
        if (globalPersistentState.popupSaveText) {
            let phraseArray = [];

            // eliminate all punctuation and other stuff in words
            let wordStr = globalPersistentState.popupSaveText.replace(/\./g, ' ' + endSentence + ' ').toLowerCase();
            wordStr = wordStr.replace(/[^a-z ]/g, ' ');
            wordStr = wordStr.replace(/\s\s+/g, ' ');

            // create an array of phrase objects
            const wordList = wordStr.split(' ');
            for (let w = 0; w < wordList.length; w++) {
                const word1 = (wordList[w].charAt(0).toUpperCase() + wordList[w].substring(1)).trim();
                if (word1.length > 0 && english.indexOf(word1.toLowerCase()) === -1 && word1 !== endSentence) {
                    insertPhrase(word1, w,1, phraseArray);
                    if (w + 1 < wordList.length) {
                        const word2 = (wordList[w + 1].charAt(0).toUpperCase() + wordList[w + 1].substring(1)).trim();
                        if (word2.length > 0 && english.indexOf(word2.toLowerCase()) === -1 && word2 !== endSentence) {
                            insertPhrase(word1 + ' ' + word2, w, 2, phraseArray);
                            if (w + 2 < wordList.length) {
                                const word3 = (wordList[w + 2].charAt(0).toUpperCase() + wordList[w + 2].substring(1)).trim();
                                if (word3.length > 0 && english.indexOf(word3.toLowerCase()) === -1 && word3 !== endSentence) {
                                    insertPhrase(word1 + ' ' + word2 + ' ' + word3, w, 3, phraseArray);
                                }
                            }
                        }
                    }
                }
            }

            // split each phrase and add up counts of each word
            for (let l = 0; l < phraseArray.length; l++) {
                let phraseObj = phraseArray[l];
                const phraseParts = phraseObj.keyPhrase.split(' ');
                let weight = 0;
                for (let p = 0; p < phraseParts.length; p++) {
                    const part = phraseParts[p];
                    const found = phraseArray.find(obj => obj.keyPhrase === part);
                    if (found) weight = weight + found.count;
                }
                phraseObj.weight = weight;
            }

            phraseArray = phraseArray.sort(compareWeight);
            setUnselectedPhrases(phraseArray);
        }
    }, [globalPersistentState.popupSaveText]);

    useEffect(() => {
    }, [globalLayoutState.editTabBarHeight]);

    useEffect(() => {
        let newList = [...selectedPhrases];
        newList = newList.sort(compareWeight);
        const selectionStr = newList.map(e => e.keyPhrase).join(', ');
        setSelectionComma(selectionStr)
        setSelectionBullet(selectionStr.replace(/,\s+/g, ' • '))
        setSelectionList(`<ul>\n\t<li>${selectionStr.replace(/,\s+/g, '</li>\n\t<li>')}</li>\n</ul>`)
    }, [selectedPhrases]);

    const handleSelectPhrase = (chipToMove) => () => { // i never understand why this is
        const newUnselections = unselectedPhrases.filter(s => s.keyPhrase !== chipToMove.keyPhrase);
        setUnselectedPhrases(newUnselections.sort(compareWeight));

        const newSelections = [...selectedPhrases, chipToMove];
        setSelectedPhrases(newSelections.sort(compareWeight));
    };

    const handleUnselectPhrase = (chipToMove) => () => { // i never understand why this is
        const newSelections = selectedPhrases.filter(s => s.keyPhrase !== chipToMove.keyPhrase);
        setSelectedPhrases(newSelections.sort(compareWeight));

        const newUnselections = [...unselectedPhrases, chipToMove];
        setUnselectedPhrases(newUnselections.sort(compareWeight));
    };

    const handleRadioChange = (event) => {
        setSelectedRadio(parseInt(event.target.value));
    };

    return (
        <div className={classes.root}>
            <div>
                <Grid container>
                    <Grid item xs={12}>
                        <div>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Number of words in phrase</FormLabel>
                                <RadioGroup aria-label="phraseWords" name="phraseWords" className={classes.radios}
                                            value={selectedRadio}
                                            onChange={handleRadioChange}>
                                    <FormControlLabel value={0} control={<Radio/>} label="All"/>
                                    <FormControlLabel value={1} control={<Radio/>} label="One Word"/>
                                    <FormControlLabel value={2} control={<Radio/>} label="Two Words"/>
                                    <FormControlLabel value={3} control={<Radio/>} label="Three Words"/>
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" gutterBottom>Unselected</Typography>
                        <Paper component="ul" className={classes.selections}>
                            {unselectedPhrases.map((row, idx) => {
                                if (selectedRadio === 0 || selectedRadio === row.wordCount) {
                                    return (
                                        <li key={idx}>
                                            <Chip
                                                size="small"
                                                label={`${row.keyPhrase} (${row.weight})`}
                                                onDelete={handleSelectPhrase(row)}
                                                deleteIcon={<DoneIcon/>}
                                            />
                                        </li>
                                    );
                                }
                                return null;
                            })}
                        </Paper>
                        <Typography variant="subtitle1" gutterBottom>Selected ({selectedPhrases.length})</Typography>
                        <Paper component="ul" className={classes.selections}>
                            {selectedPhrases.map((row, idx) => {
                                return (
                                    <li key={idx}>
                                        <Chip
                                            size="small"
                                            label={`${row.keyPhrase} (${row.weight})`}
                                            onDelete={handleUnselectPhrase(row)}
                                        />
                                    </li>
                                );
                            })}
                        </Paper>
                    </Grid>
                    <Grid item xs={8}>
                    </Grid>
                    <Grid item xs={2} className={classes.buttons}>
                        <Button
                            id={"btn-trends"}
                            fullWidth
                            variant="contained"
                            disabled={selectedPhrases.length === 0 || selectedPhrases.length > 5}
                            onClick={() => {
                                const gturl = 'https://trends.google.com/trends/explore?geo=US&q=';
                                window.open(gturl + selectionComma);
                            }}
                            color="secondary"
                        >
                            Trends
                        </Button>
                    </Grid>
                    <Grid item xs={2} className={classes.buttons}>
                        <div>
                            <Button
                                aria-controls="copy-menu"
                                aria-haspopup="true"
                                variant="contained"
                                color="primary"
                                onClick={handleCopyClick}
                                disabled={selectedPhrases.length === 0}
                            >
                                Copy...
                            </Button>
                            <StyledMenu
                                id="copy-menu"
                                anchorEl={copyAnchorEl}
                                keepMounted
                                open={Boolean(copyAnchorEl)}
                                onClose={handleCopyClose}
                            >
                                <StyledMenuItem>
                                    <ListItemText
                                        primary="Copy Comma Separated"
                                        onClick={(event) => handleCopyItemClick(event, "comma")}
                                    />
                                </StyledMenuItem>
                                <StyledMenuItem>
                                    <ListItemText
                                        primary="Copy Bullet Separated"
                                        onClick={(event) => handleCopyItemClick(event, "bullet")}
                                    />
                                </StyledMenuItem>
                                <StyledMenuItem>
                                    <ListItemText
                                        primary="Copy HTML List"
                                        onClick={(event) => handleCopyItemClick(event, "html")}
                                    />
                                </StyledMenuItem>
                            </StyledMenu>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </div>
    )
};

export default PopupAnalyzeKeywords
